import { render, staticRenderFns } from "./PasswordUpdate.vue?vue&type=template&id=22a91e42&scoped=true"
import script from "./PasswordUpdate.vue?vue&type=script&lang=js"
export * from "./PasswordUpdate.vue?vue&type=script&lang=js"
import style0 from "./PasswordUpdate.vue?vue&type=style&index=0&id=22a91e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a91e42",
  null
  
)

export default component.exports